var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgStar = function SvgStar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 29 29"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "Star_svg__a",
    width: 29,
    height: 29,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M28.5.566H.5v28h28z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#Star_svg__a)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#Star_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#Star_svg__c)",
    d: "M7.725 2.22c.033-.518.74-.643.961-.17 1.615 3.458 5.073 5.766 8.881 5.99.539.031.68.772.188.985-3.48 1.51-5.864 4.85-6.103 8.634-.033.519-.74.644-.962.17-1.615-3.457-5.073-5.765-8.881-5.99-.538-.03-.68-.771-.187-.985 3.478-1.51 5.863-4.85 6.103-8.633"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#Star_svg__d)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#Star_svg__e)",
    d: "M23.468 13.56c.063-.256.428-.256.49 0a5.14 5.14 0 0 0 3.76 3.76c.257.064.257.428 0 .491a5.14 5.14 0 0 0-3.76 3.76c-.062.257-.427.257-.49 0a5.14 5.14 0 0 0-3.76-3.76c-.256-.063-.256-.427 0-.49a5.14 5.14 0 0 0 3.76-3.76"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "Star_svg__c",
    x1: 5.501,
    x2: 10.316,
    y1: 15.566,
    y2: 3.517,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.249,
    stopColor: "#6A77FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFDCD8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Star_svg__e",
    x1: 22.028,
    x2: 25.798,
    y1: 23.121,
    y2: 13.233,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.249,
    stopColor: "#5865F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFDCD8"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Star_svg__b",
    width: 17.413,
    height: 17.044,
    x: 0.644,
    y: 1.08,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -0.675,
    dy: -0.675
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.483
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    k2: -1,
    k3: 1,
    operator: "arithmetic"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.455758 0 0 0 0 0.218021 0 0 0 0 0.758333 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "shape",
    result: "effect1_innerShadow_975_7639"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Star_svg__d",
    width: 9.071,
    height: 9.07,
    x: 18.841,
    y: 12.693,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -0.675,
    dy: -0.675
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.483
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    k2: -1,
    k3: 1,
    operator: "arithmetic"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.455758 0 0 0 0 0.218021 0 0 0 0 0.758333 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "shape",
    result: "effect1_innerShadow_975_7639"
  })))));
};
export default SvgStar;